import React, { useEffect, useRef } from 'react';
import { SplashScreen } from '@capacitor/splash-screen';
import PulseLogo from '../components/PulseLogo';

interface SplashProps {
    onReady(): void;
}

export function Splash({ onReady }: SplashProps) {
    const styleRef = useRef<HTMLStyleElement | null>(null);

    useEffect(() => {
        // Inject styles via DOM to avoid React reconciliation issues
        const style = document.createElement('style');
        style.textContent = `
          @keyframes splash-spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes splash-pulse {
            0%, 100% { opacity: 0.8; }
            50% { opacity: 0.4; }
          }
        `;
        document.head.appendChild(style);
        styleRef.current = style;

        return () => {
            if (styleRef.current && styleRef.current.parentNode) {
                styleRef.current.parentNode.removeChild(styleRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const initializeApp = async () => {
            try {
                await new Promise(resolve => setTimeout(resolve, 1000));

                const rootStyles = getComputedStyle(document.documentElement);
                const primaryColor = rootStyles.getPropertyValue('--primary');

                if (!primaryColor.trim()) {
                    await new Promise(resolve => setTimeout(resolve, 500));
                }

                await SplashScreen.hide();
                await new Promise(resolve => setTimeout(resolve, 300));

                onReady();
            } catch (error) {
                console.warn('Erro ao inicializar splash:', error);
                onReady();
            }
        };

        initializeApp();
    }, [onReady]);

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 9999,
                height: '100dvh',
                paddingTop: 'env(safe-area-inset-top)',
                paddingBottom: 'env(safe-area-inset-bottom)',
                background: 'linear-gradient(135deg, #c31432, #240b36)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                gap: '2rem',
            }}
        >
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        width: '160px',
                        height: '160px',
                        border: '3px solid rgba(255, 255, 255, 0.2)',
                        borderTop: '3px solid #ffffff',
                        borderRadius: '50%',
                        animation: 'splash-spin 1s linear infinite',
                    }}
                />
                <div
                    style={{
                        width: '120px',
                        height: '120px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1,
                    }}
                >
                    <PulseLogo size="lg" variant="white" />
                </div>
            </div>
            <div
                style={{
                    color: '#ffffff',
                    fontSize: '16px',
                    fontWeight: '300',
                    textAlign: 'center',
                    opacity: 0.8,
                    animation: 'splash-pulse 1.5s ease-in-out infinite',
                }}
            >
                Carregando...
            </div>
        </div>
    );
}